/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 26/04/2022
 */

import React, { PropsWithChildren } from 'react';
import { Page as PDFPage, View, StyleSheet } from '@react-pdf/renderer';
import Header from '@/wpt-lib/pdf/common/Header';
import Footer from '@/wpt-lib/pdf/common/Footer';

const Page: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <PDFPage size="A4" orientation="landscape" style={styles.page}>
            <Header />
            <View style={styles.main}>{children}</View>
            <Footer />
        </PDFPage>
    );
};

const styles = StyleSheet.create({
    page: {
        display: 'flex',
        padding: 5,
        width: '100%',
    },
    main: {
        flexGrow: 1,
        width: '100%',
        paddingHorizontal: 30,
    },
});

export default Page;
